import React, { useMemo } from "react";
import { IconButton, Tooltip, Typography } from "@mui/material";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";

export default function ContextTooltip({ title, description, icon = <HelpOutlineRoundedIcon fontSize="small" />, placement = "top", ...props }) {
    const tooltipContent = useMemo(() => (
        <>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                {title}
            </Typography>
            {description ? (
                <Typography variant="body2" sx={{ mt: 0.5 }}>
                    {description}
                </Typography>
            ) : null}
        </>
    ), [title, description]);

    return (
        <Tooltip title={tooltipContent} placement={placement} arrow {...props}>
            <IconButton size="small" color="primary" aria-label={typeof title === "string" ? title : "Kontext-Hilfe"}>
                {icon}
            </IconButton>
        </Tooltip>
    );
}
